import { ApolloProvider } from '@apollo/client';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { pl as pluralsPl } from 'make-plural/plurals';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Router } from 'react-router-dom';

import config from './config/config';
import CurrentUser from 'Components/CurrentUser/CurrentUser';
import Entry from 'Components/Entry/Entry';
import { LocalSettingsProvider } from 'Components/LocalSettingsProvider/LocalSettingsProvider';
import { SnackbarProvider } from 'uikit/Snackbar';
// Should create instance of FCMManager
import 'utils/FCMManager/FCMManager';
// PAGES
import { client } from 'utils/apolloConnector/apolloConnector';
import { focusManager } from 'utils/focusManager/focusManager';
import history from 'utils/history/history';

import './App.scss';
/* @ts-expect-error type mismatch */
import { messages } from './locales/pl/messages';
import { initializeCookieStorage, ENV } from 'utils/cookies/cookieStorage';

export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

const locale = config.LOCALE;

i18n.loadLocaleData({
  [locale]: { plurals: pluralsPl },
});
i18n.load(locale, messages);
i18n.activate(locale);
focusManager();

const App = () => {
  // Initialize cookie storage on mount
  try {
    useIsomorphicLayoutEffect(() => {
      const isProduction = process.env.NODE_ENV === 'production';
      const environment = isProduction ? ENV.PRD : ENV.STG;
      const debugMode = !isProduction;
      initializeCookieStorage(environment, debugMode);
    }, []);
  } catch (error) {
    console.error('Error initializing cookie storage:', error);
  }

  return (
    <CurrentUser>
      <LocalSettingsProvider>
        <HelmetProvider>
          <ApolloProvider client={client}>
            <I18nProvider i18n={i18n}>
              <SnackbarProvider>
                <Router history={history}>
                  <Entry />
                </Router>
              </SnackbarProvider>
            </I18nProvider>
          </ApolloProvider>
        </HelmetProvider>
      </LocalSettingsProvider>
    </CurrentUser>
  );
};

export default App;
